<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        v-model="params.status"
        placeholder="订单状态"
        size="small"
        @change="getList('status')"
        clearable
      >
        <el-option
          v-for="item in statuses"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="params.isReset"
        placeholder="是否重置订单"
        size="small"
        @change="getList('status')"
      >
        <el-option
          v-for="item in resetOpt"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        v-model="params.uid"
        placeholder="请输入用户ID"
        clearable
        @change="getList('status')"
        size="small"
        style="width: 280px"
      ></el-input>
      <el-input
        v-model="params.advOid"
        placeholder="请输入预付订单号"
        clearable
        @change="getList('status')"
        size="small"
        style="width: 280px;margin-left: 20px;"
      ></el-input>
      <el-input
        v-model="params.balOid"
        placeholder="请输入尾款订单号"
        clearable
        @change="getList('status')"
        size="small"
        style="width: 280px;margin-left: 20px;"
      ></el-input>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" align="center" width="120">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1">预付中</el-tag>
          <el-tag type="success" v-else-if="scope.row.status == 2"
            >预付成功</el-tag
          >
          <el-tag type="danger" v-if="scope.row.status == 3">尾款预付中</el-tag>
          <el-tag type="success" v-else-if="scope.row.status == 4"
            >尾款预付成功</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="advOid"
        label="预付订单号"
        align="center"
        min-width="210"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.advOid || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="advanceAmount"
        label="预付金额"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.advanceAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="balOid"
        label="尾款订单号"
        align="center"
        min-width="210"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.balOid || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="balanceAmount"
        label="尾款金额"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.balanceAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalAmount"
        label="预售总金额"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productID"
        label="产品ID"
        align="center"
        min-width="210"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.productID || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.endTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operating"
        label="操作"
        align="center"
        width="160"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="reset(scope.row)"
            type="danger"
            v-if="
              (scope.row.status == 0 || scope.row.status == 1) &&
                !scope.row.isReset
            "
            >重置</el-button
          >
          <el-button
            size="mini"
            @click="recover(scope.row)"
            type="danger"
            v-if="scope.row.isReset"
            >恢复</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        status: undefined,
        advOid: undefined,
        balOid: undefined,
        uid: undefined,
        isReset: false,
      },
      resetOpt: [
        {
          label: "重置订单",
          value: true,
        },
        {
          label: "正常订单",
          value: false,
        },
      ],
      statuses: [
        {
          label: "预付中",
          value: 1,
        },
        {
          label: "预付成功",
          value: 2,
        },
        {
          label: "尾款预付中",
          value: 3,
        },
        {
          label: "尾款预付成功",
          value: 4,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getAdvanceOrderList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset(item) {
      this.$confirm("您确定要重置该订单吗？", "重置提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let req = {
          id: item.id,
        };
        API.resetAdvanceOrderList(req)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "重置成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error("重置失败！");
            }
          })
          .catch(() => {
            this.flag = false;
            this.getList();
            this.$message.error("重置失败！");
          });
      });
    },
    recover(item) {
      this.$confirm("您确定要恢复该订单吗？", "恢复提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let req = {
          id: item.id,
        };
        API.recoverAdvanceOrderList(req)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "恢复成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error("恢复失败！");
            }
          })
          .catch(() => {
            this.flag = false;
            this.getList();
            this.$message.error("恢复失败！");
          });
      });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.picturePreview {
  max-width: 300px;
  display: flex;
}
</style>
